import React, { Fragment, useEffect, useState } from "react";
import { formatMessageTime } from "../../common/const";
import CommonCard from "../../common/components/CommonCard";
import { Avatar, Box, Divider, Typography } from "@mui/material";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import { ArrowDropDown, Person } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const PendingMessages = ({
    chatList
}) => {
    const navigate = useNavigate();
    const [imageUrls, setImageUrls] = useState({});
    const [imageErrors, setImageErrors] = useState({});

    useEffect(() => {
        if (chatList?.length > 0) {
            const usersWithAvatars = chatList
                .filter(chat => (chat?.student?.avatar))
                .map(chat => ({
                    userId: chat?.student_id,
                    avatarPath: chat.student?.avatar
                }));

            const loadAllImages = async () => {
                const imagePromises = usersWithAvatars.map(async (user) => {
                    if (!imageUrls[user.userId] && !imageErrors[user.userId]) {
                        const fullUrl = `${process.env.REACT_APP_BASE_URL}/file?bname=${user.avatarPath}&download=false`;
                        try {
                            const response = await fetch(fullUrl, {
                                headers: {
                                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                                }
                            });

                            if (!response.ok) {
                                throw new Error(`HTTP error! status: ${response.status}`);
                            }

                            const blob = await response.blob();
                            const objectUrl = URL.createObjectURL(blob);

                            return {
                                userId: user.userId,
                                url: objectUrl
                            };
                        } catch (error) {
                            console.error('Error loading image:', error);
                            return null;
                        }
                    }
                    return null;
                });

                const results = await Promise.all(imagePromises);
                const newImageUrls = results
                    .filter(result => result !== null)
                    .reduce((acc, { userId, url }) => {
                        acc[userId] = url;
                        return acc;
                    }, {});

                setImageUrls(prev => ({
                    ...prev,
                    ...newImageUrls
                }));
            };

            loadAllImages();
        }
    }, [chatList]);

    const handleImageError = (userId) => {
        setImageErrors(prev => ({
            ...prev,
            [userId]: true
        }));
    };

    const renderAvatar = (userId, firstName, lastName, size = 45) => {
        if (imageUrls[userId] && !imageErrors[userId]) {
            return (
                <img
                    src={imageUrls[userId]}
                    alt={`${firstName} ${lastName}`}
                    width={`${size}px`}
                    height={`${size}px`}
                    style={{ borderRadius: 10, objectFit: 'cover' }}
                    onError={() => handleImageError(userId)}
                />
            );
        } else {
            const initials = `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
            return (
                <Avatar
                    sx={{
                        width: size,
                        height: size,
                        borderRadius: 1,
                        bgcolor: theme.palette.primary.main,
                        fontSize: size * 0.4,
                        fontWeight: 'bold'
                    }}
                >
                    {initials || <Person />}
                </Avatar>
            );
        }
    };


    return (
        <CommonCard
            paddingBottom="0px"
            borderRadius={2}
            headerContent={
                <Fragment>
                    <Box p={2} display="flex" alignItems="center" justifyContent="space-between">
                        <Typography fontWeight={600}>Pending Messages</Typography>
                        <CommonButton
                            label="View More"
                            marginBottom="0px"
                            width="130px"
                            height="30px"
                            background={theme.palette.background.main}
                            color={theme.palette.background.dark}
                            borderRadius={3}
                            endIcon={<ArrowDropDown sx={{ color: theme.palette.background.dark }} />}
                            fontWeight={600}
                            handleClick={() => navigate('/communication-hub')}
                        />
                    </Box>
                    <Divider />
                </Fragment>
            }
            content={
                <Fragment>
                    <Box
                        sx={{
                            height: chatList.length > 0 ? '55vh' : '5vh',
                            overflow: 'auto'
                        }}
                    >
                        {chatList.length > 0 ? (
                            chatList.map((a, index) => (
                                <CommonCard
                                    key={index}
                                    borderRadius={2}
                                    paddingBottom="0px"
                                    background="#FAFAFA"
                                    padding="13px"
                                    marginTop={index === 0 ? '0px' : '10px'}
                                    content={
                                        <Box
                                            display="flex" justifyContent="space-between" sx={{ cursor: 'pointer' }}
                                            onClick={() => navigate(`/communication-hub?id=${a?.student_id}`)}
                                        >
                                            <Box display="flex" gap={1}>
                                                {renderAvatar(
                                                    a?.student_id,
                                                    a?.student?.first_name,
                                                    a?.student?.last_name,
                                                    45
                                                )}
                                                <Box>
                                                    <Typography fontWeight={600} fontSize={16}>{`${a?.student?.first_name} ${a?.student?.last_name}`}</Typography>
                                                    <Typography color={theme.palette.background.dark} fontSize={13}>{a.last_message.length > 100 ? `${a.last_message.slice(0, 100)}....` : a.last_message}</Typography>
                                                </Box>
                                            </Box>
                                            <Box>
                                                <Typography fontSize={14}>{formatMessageTime(a.created_at)}</Typography>
                                            </Box>
                                        </Box>
                                    }
                                />
                            ))
                        ) : (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} mt={1}>
                                <Typography color={theme.palette.background.dark} fontSize={16}>No Chat Found</Typography>
                            </Box>
                        )}
                    </Box>
                </Fragment>
            }
        />
    )
}

export default PendingMessages; 